import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { colors } from '../../styles';
import { DropdownProps } from './props';
import DropdownListItem from './dropdown-list-item';

class Dropdown extends React.Component<DropdownProps, any> {
  public static defaultProps: DropdownProps = {
    listOptions: [],
  };

  render() {
    const { className, id, listOptions } = this.props;

    return (
      <div className={className}>
        {listOptions.map((listOption, key) => (
          <DropdownListItem
            {...listOption}
            id={id}
            key={key}
            onClick={listOption.onClick.bind(this, id)}
          />
        ))}
      </div>
    );
  }
}

const StyledDropdown = styled(Dropdown)`
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 ${colors.grey50}, inset 0 0 0 1px ${colors.grey500};
  display: flex;
  flex-flow: column nowrap;
  min-width: 11rem;
  z-index: 1;

  .none {
    cursor: default;
    justify-content: center;
  }
`;

export default StyledDropdown;
